window.dataLayer = window.dataLayer || [];

const googleEvent = {
  send(data) {
    window.dataLayer.push(data)
  },
  itineraryClass: {
    economy: 'Premium Class',
    premium: 'Premium Class',
    business: 'Business Class',
    first: 'First Class',
  },
  itineraryType: {
    oneWay: 'One Way',
    roundTrip: 'Round Trip',
    multi: 'Multi City',
  },
  trID: 0,
  product: {},
  onStep1() {
    this.send({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: 1,
            option: 'Itinerary'
          },
          products: [this.product],
        },
      },
    })
  },
  onStep2() {
    this.send({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: 2,
            option: 'Passengers'
          },
          products: [this.product],
        },
      },
    })
  },
  onStep3() {
    this.send({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: 3,
            option: 'Ticket Protection'
          },
          products: [this.product],
        },
      },
    })
  },
  onStep4() {
    this.send({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: 4,
            option: 'Payment information'
          },
          products: [this.product],
        },
      },
    })
  },
  onSuccess() {
    this.send({
      event: "gtm-ee-event",
      gtmUaEventCategory: "Enhanced Ecommerce",
      gtmUaEventAction: "Transaction Push",
      gtmUaEventNonInteraction: "True",
      ecommerce: {
        currencyCode: 'USD',
        purchase: {
          actionField: {
            id: this.trID, // Transaction ID
            revenue: this.product.price * 0.05,
          },
          products: [this.product],
        },
      },
    })
  },
  onSetPriceQuote( selectedFlight, apiData ) {
    // console.log('onSetPriceQuote', selectedFlight, apiData);
    const from = selectedFlight.parts?.depart?.from || selectedFlight.parts.multiple[0].from
    const to = selectedFlight.parts?.depart?.to || selectedFlight.parts.multiple[selectedFlight.parts.multiple.length - 1].to
    const type = selectedFlight.parts?.multiple?.length > 0 ? 'multi' : (selectedFlight.parts?.return?.length > 0 ? 'roundTrip' : 'oneWay')

    this.trID = selectedFlight.id
    
    const newPath = window.location.pathname.replace(/(.*)\/.*/, '$1/'+this.trID)
    window.history.pushState({urlPath: newPath}, document.title, newPath)

    this.product = {
      name: `${from} - ${to}`,
      id: `${from}2${to}`,
      price: selectedFlight.priceOffer,
      category: this.itineraryType[type],
      quantity: 1,
    }
  }
}

export default googleEvent
